import * as React from 'react';
import { makeStyles } from '@fluentui/react-components';
import StickyHeader from './StickyHeader';
import HeroSection from './HeroSection';
import ScheduleSection from './ScheduleSection';
import PhotoUploadSection from './PhotoUploadSection';
import FAQSection from './FAQSection';
import RSVPSection from './RSVPSection';
import Footer from './Footer';
import themeImage from '../assets/theme.jpg';
import { FONT_FAMILY } from './sharedStyles';

interface LayoutProps {
  activeSection: 'home' | 'schedule' | 'photos' | 'faq' | 'rsvp' | 'admin';
  setActiveSection: (section: 'home' | 'schedule' | 'photos' | 'faq' | 'rsvp' | 'admin') => void;
}

const useStyles = makeStyles({
  body: {
    margin: 0,
    fontFamily: FONT_FAMILY,
    background: `url(${themeImage}) center/cover no-repeat fixed, linear-gradient(to bottom right, #fff8e1, #ffe0b2)`,
    color: '#3a2a1a',
    overflowX: 'hidden',
    paddingTop: '56px',
    scrollBehavior: 'smooth',
    scrollPaddingTop: '80px',
    minHeight: '100vh',
    '@media (max-width: 768px)': {
      paddingTop: '90px',
      scrollPaddingTop: '100px',
    },
  },
});

const Layout: React.FC<LayoutProps> = ({ activeSection, setActiveSection }) => {
  const classes = useStyles();

  const scrollToSection = (sectionId: string) => {
    setActiveSection(sectionId as 'home' | 'schedule' | 'photos' | 'faq' | 'rsvp' | 'admin');
    
    if (sectionId === 'admin') {
      return;
    }
    
    const section = document.getElementById(sectionId);
    if (section) {
      // Dynamic header height calculation for mobile
      const isMobile = window.innerWidth <= 768;
      const headerHeight = isMobile ? 100 : 80;
      const sectionTop = section.offsetTop - headerHeight;
      window.scrollTo({
        top: sectionTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className={classes.body}>
      <StickyHeader 
        setActiveSection={setActiveSection} 
        scrollToSection={scrollToSection} 
      />
      
      <HeroSection />

      <main>
        <ScheduleSection />
        <PhotoUploadSection />
        <FAQSection />
        <RSVPSection />
      </main>

      <Footer />
    </div>
  );
};

export default Layout;